import React, { useState, useEffect } from 'react';
import useSWR from 'swr';
import api from '~/_base/constants/api';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import ErrorBoundary from '~/frontend/modules/errorBoundary';

interface PageProps {
  title?: string;
  children: React.ReactNode;
}

export default function Page(props: PageProps) {
  const navigate = useNavigate();
  const [retry, setRetry] = useState(false);
  const theme = useTheme();
  const { data: currentContext } = useSWR(
    api.currentContext.address,
    api.currentContext.request
  );
  const { data: navigationData } = useSWR(
    api.topNavigation.address,
    api.topNavigation.request
  );

  const liveViewEnabled = navigationData
    ?.filter(menu => menu.key === 'insights')
    .some(
      menu =>
        'items' in menu &&
        menu.items.some(menuItem => menuItem.uri === '/live_view')
    );

  const siteAssistantEnabled = navigationData
    ?.filter(menu => menu.key === 'insights')
    .some(
      menu =>
        'items' in menu &&
        menu.items?.some(menuItem => menuItem.uri === '/site_assistant')
    );

  useEffect(() => {
    document.title = `Damstra Forms${props.title ? ` | ${props.title}` : ''}`;
  }, [props.title]);


  return (
    <React.Fragment>
      <Box component="main" p={3} pr={liveViewEnabled || siteAssistantEnabled ? 5 : undefined} flex={1} overflow="auto">
        <Box sx={theme.mixins.toolbar} />
        <ErrorBoundary
          goHome={() => navigate('/')}
          retry={() => setRetry(!retry)}
          context={{
            current_user_email: currentContext?.current_user.email,
            current_project: currentContext?.current_project?.name,
          }}
        >
          {props.children}
        </ErrorBoundary>
      </Box>
    </React.Fragment>
  );
}
